import { EnumBase } from 'hay-core-react';
class PlanoRenovacaoNavegacaoEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.plano.renovacaonavegacao.nunca',
                'main.plano.renovacaonavegacao.diaria',
                'main.plano.renovacaonavegacao.semanal',
                'main.plano.renovacaonavegacao.mensal',
            ],
            'main.plano.renovacaonavegacao.nunca'
        );
    }
}

const instance = new PlanoRenovacaoNavegacaoEnum();
export default instance;
